"use client";

import { ChartProductUsageStackedBarProps } from "../types";

export function ChartProductUsageStackedBar({
  products,
  viewMode,
  totalMonetary,
  totalCredits,
  getColor,
}: ChartProductUsageStackedBarProps) {
  const parse = (v: string | number) => Number.parseFloat(String(v || 0));

  const total =
    viewMode === "currency" ? parse(totalMonetary) : parse(totalCredits);

  return (
    <div className="w-full my-6 px-6">
      <div className="flex h-4 rounded-lg overflow-hidden bg-secondary">
        {products.map((product, idx) => {
          const value =
            viewMode === "currency"
              ? parse(product.monetary_value)
              : parse(product.credits_value);

          const pct = total > 0 ? (value / total) * 100 : 0;

          return (
            <div
              key={`${product.type}-${idx}`}
              className={`h-full bg-${getColor(product.type)} border-r border-white`}
              style={{ width: `${pct}%` }}
              title={`${product.type} - ${pct.toFixed(1)}%`}
              data-testid={`chart-product-usage-stacked-bar-${product.type}`}
            />
          );
        })}
      </div>
    </div>
  );
}
